$(document).on("ifChanged","[name='principalactiv']",function(){
	if($("[name='principalactiv'][value='Others']").is(":checked")){
		$('.principalOther').show();
	}else{
		$('.principalOther').hide();
	}
}).on("change",".areatematica",function(){
	$(this).closest("form").submit();
}).on("keyup",".formabstract #abstract",function(){
	var contador_palabras = $(this).val();
	contador_palabras = contador_palabras.trim();
	var espacios = 1;
	var max_palabras = 500;
	for(var cont=0;cont<contador_palabras.length;cont++){
		if(contador_palabras[cont]==" "){
			espacios++; 
		}
	}
	if(contador_palabras==""){
		espacios = 0;
	}
	$('.palRestantes').text(max_palabras-espacios);

})

$.fn.serializeObject = function()
{
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};


function compobarMember(){
	var res = true;
	$('.markedfields').hide();
	$('.msgok').hide();
	$('.msgko').hide();
	$('.memberform div').removeClass("has-error");
	$('.memberform .obli').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").addClass("has-error");
			res = false;
		}
	})

	var principalactiv = $('[name="principalactiv"]:checked').length;
	if(principalactiv==0){
		$('[name="principalactiv"]').closest("div").addClass("has-error");
		res = false;
	}

	var publicationsmem = $('[name="publicationsmem"]:checked').length;
	if(publicationsmem==0){
		$('[name="publicationsmem"]').closest("div").addClass("has-error");
		res = false;
	}

	var acepto_condi = $('.acepto_condi:checked').length;
	if(acepto_condi==0){
		$('.acepto_condi').closest("div").addClass("has-error");
		res = false;
	}

	var colmemb_email_cont = $('#colmemb_email_cont').val();
	var colmemb_email_cont2 = $('#colmemb_c_email_cont').val();
	if(colmemb_email_cont.trim()!=colmemb_email_cont2.trim()){
		$('#colmemb_email_cont').closest("div").addClass("has-error");
		$('#colmemb_c_email_cont').closest("div").addClass("has-error");
		res = false;
	}

	

	if(!res){
		$('.memberform').closest("div").find(".markedfields").show();
		$('html, body').animate({
	          scrollTop: 0
	    }, 600);
	}

	

	return res;

}

function memberform(){
	$('.memberform .enviarRes').prop("disabled",true);
	var json = $('.memberform').serializeObject();
	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
	var csrfToken = $('meta[name="csrf-token"]').attr("content");
	json._csrf = csrfToken;
	json.page = page;
	json.lang_id = lang_id;
	$.post("/ajax/memberform",json,function(data){
		if(data.code==1){
			$('.memberform').closest("div").find(".markedfields").hide();
			$('.memberform').closest("div").find(".msgok").show();
			$('.memberform').closest("div").find(".msgko").hide();
			$('.memberform').closest("div").find(".memberform").hide();
		}
	},"json");
}

function compobarMemberaf(){
	var res = true;
	$('.markedfields').hide();
	$('.msgok').hide();
	$('.msgko').hide();
	$('.memberformaf div').removeClass("has-error");
	$('.memberformaf .obli').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").addClass("has-error");
			res = false;
		}
	})

	var principalactiv = $('[name="principalactiv"]:checked').length;
	if(principalactiv==0){
		$('[name="principalactiv"]').closest("div").addClass("has-error");
		res = false;
	}

	var publicationsmem = $('[name="publicationsmem"]:checked').length;
	if(publicationsmem==0){
		$('[name="publicationsmem"]').closest("div").addClass("has-error");
		res = false;
	}

	var acepto_condi = $('.acepto_condi:checked').length;
	if(acepto_condi==0){
		$('.acepto_condi').closest("div").addClass("has-error");
		res = false;
	}

	var colmemb_email_cont = $('#colmemb_email_cont').val();
	var colmemb_email_cont2 = $('#colmemb_c_email_cont').val();
	if(colmemb_email_cont.trim()!=colmemb_email_cont2.trim()){
		$('#colmemb_email_cont').closest("div").addClass("has-error");
		$('#colmemb_c_email_cont').closest("div").addClass("has-error");
		res = false;
	}

	

	if(!res){
		$('.memberformaf').closest("div").find(".markedfields").show();
		$('html, body').animate({
	          scrollTop: 0
	    }, 600);
	}

	

	return res;

}

function memberformaf(){
	$('.memberformaf .enviarRes').prop("disabled",true);
	var json = $('.memberformaf').serializeObject();
	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
	var csrfToken = $('meta[name="csrf-token"]').attr("content");
	json._csrf = csrfToken;
	json.page = page;
	json.lang_id = lang_id;
	$.post("/ajax/memberformaf",json,function(data){
		if(data.code==1){
			$('.memberformaf').closest("div").find(".markedfields").hide();
			$('.memberformaf').closest("div").find(".msgok").show();
			$('.memberformaf').closest("div").find(".msgko").hide();
			$('.memberformaf').closest("div").find(".memberformaf").hide();
		}
	},"json");
}

function contactoform(){
	$('.contactonor .enviarRes').prop("disabled",true);
	var json = $('.contactonor').serializeObject();
	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
	var csrfToken = $('meta[name="csrf-token"]').attr("content");
	json.page = page;
	json.lang_id = lang_id;
	json._csrf = csrfToken;
	$.post("/ajax/contactoform",json,function(data){
		if(data.code==1){
			$('.contactonor').closest("div").find(".markedfields").hide();
			$('.contactonor').closest("div").find(".msgok").show();
			$('.contactonor').closest("div").find(".msgko").hide();
			$('.contactonor').hide();
		}
	},"json");
}

function comprobarAbstract(){
	var res = true;
	$('.markedfields').hide();
	$('.msgok').hide();
	$('.msgko').hide();
	$('.formabstract div').removeClass("has-error");
	$('.formabstract .obli').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").addClass("has-error");
			res = false;
		}
	})

	$('.formabstract select.obliselect').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").parent("div").addClass("has-error");
			res = false;
		}
	})

	var keyword1 = $('#keyword1').val();
	var keyword2 = $('#keyword2').val();
	var keyword3 = $('#keyword3').val();
	var keyword4 = $('#keyword4').val();
	if(keyword1.trim()=="" && keyword2.trim()=="" && keyword3.trim()=="" && keyword4.trim()==""){
		res = false;
		$("#keyword1").closest("div").addClass("has-error");
		$("#keyword2").closest("div").addClass("has-error");
		$("#keyword3").closest("div").addClass("has-error");
		$("#keyword4").closest("div").addClass("has-error");
		$(".keywordsTit").closest("div").addClass("has-error");
	}

	var area1 = $('#area1').val();
	var area2 = $('#area2').val();
	var area3 = $('#area3').val();
	if(area1.trim()=="" && area2.trim()=="" && area3.trim()==""){
		res = false;
		$("#area1").closest("div").parent("div").addClass("has-error");
		$("#area2").closest("div").parent("div").addClass("has-error");
		$("#area3").closest("div").parent("div").addClass("has-error");
		$(".researchAreas").closest("div").addClass("has-error");
	}


	if(!res){
		$('.formabstract').closest("div").find(".markedfields").show();
		$('html, body').animate({
	          scrollTop: 0
	    }, 600);
	}

	

	return res;

}

function abstractform(){
	$('.formabstract .enviarRes').prop("disabled",true);
	var json = $('.formabstract').serializeObject();
	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
	var csrfToken = $('meta[name="csrf-token"]').attr("content");
	json._csrf = csrfToken;
	json.page = page;
	json.lang_id = lang_id;
	$.post("/ajax/abstractform",json,function(data){
		if(data.code==1){
			$('.formabstract').closest("div").find(".markedfields").hide();
			$('.formabstract').closest("div").find(".msgok").show();
			$('.formabstract').closest("div").find(".msgko").hide();
			$('.formabstract').hide();
		}
	},"json");
}

function comprobarNewbook(){
	var res = true;
	$('.markedfields').hide();
	$('.msgok').hide();
	$('.msgko').hide();
	$('.formnewbook div').removeClass("has-error");
	$('.formnewbook .obli').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").addClass("has-error");
			res = false;
		}
	})


	var year = $('#year').val();

	if(isNaN(year.trim()) || year.trim().length<4){
		res = false;
		$('#year').closest("div").addClass("has-error");
	}


	if(!res){
		$('.formnewbook').closest("div").find(".markedfields").show();
		$('html, body').animate({
	          scrollTop: 0
	    }, 600);
	}

	

	return res;

}

function newbookform(){
	$('.formnewbook .enviarRes').prop("disabled",true);
	var json = $('.formnewbook').serializeObject();
	var page = $('body').attr("data-id");
	var lang_id = $('body').attr("data-lang_id");
  	var csrfToken = $('meta[name="csrf-token"]').attr("content");
	json.page = page;
	json._csrf = csrfToken;
	json.lang_id = lang_id;
	$.post("/ajax/newbookform",json,function(data){
		if(data.code==1){
			$('.formnewbook').closest("div").find(".markedfields").hide();
			$('.formnewbook').closest("div").find(".msgok").show();
			$('.formnewbook').closest("div").find(".msgko").hide();
			$('.formnewbook').hide();
		}
	},"json");
}

function compobarContacto(){
	var res = true;
	$('.markedfields').hide();
	$('.msgok').hide();
	$('.msgko').hide();
	$('.contactonor div').removeClass("has-error");
	$('.contactonor .obli').each(function(){
		var valor = $(this).val();
		if(valor.trim()==""){
			$(this).closest("div").addClass("has-error");
			res = false;
		}
	})

	

	var acepto_condi = $('.acepto_condi:checked').length;
	if(acepto_condi==0){
		$('.acepto_condi').closest("div").addClass("has-error");
		res = false;
	}

	var colmemb_email_cont = $('#contacto_email').val();
	var colmemb_email_cont2 = $('#contacto_c_email').val();
	if(colmemb_email_cont.trim()!=colmemb_email_cont2.trim()){
		$('#contacto_email').closest("div").addClass("has-error");
		$('#contacto_c_email').closest("div").addClass("has-error");
		res = false;
	}

	

	if(!res){
		$('.contactonor').closest("div").find(".markedfields").show();
		$('html, body').animate({
	          scrollTop: 0
	    }, 600);
	}

	

	return res;

}
$(document).on("click",".cerrarpol",function(){
    $.get("/ajax/addpol",{},function(data){
        $("#politica").slideToggle();
    })
});
